module.exports = __webpack_public_path__ + "media/images/company/company_02_02-2269071c49cbffb5654b25a5d86328e1.jpg";